const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Свідоцтво про реєстрацію транспортного засобу',
	'vehicleRegistrationDocument.description':
		'Завантажте чіткі фотографії запитаних сторін свідоцтва про реєстрацію.',
	'vehicleRegistrationDocument.RegistrationDocument.title':
		'Лицьова сторона свідоцтва про реєстрацію',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Зробіть чітку фотографію лицьової сторони свідоцтва про реєстрацію.',
	'vehicleRegistrationDocument.RegistrationDocument.headline':
		'Лицьова сторона свідоцтва про реєстрацію',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Лицьова сторона свідоцтва про реєстрацію - приклад',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Лицьова сторона свідоцтва про реєстрацію',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Зворотна сторона свідоцтва про реєстрацію',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Зробіть чітку фотографію зворотної сторони свідоцтва про реєстрацію.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Зворотна сторона свідоцтва про реєстрацію',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Зворотна сторона свідоцтва про реєстрацію - приклад',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Зворотна сторона свідоцтва про реєстрацію',
	'vehicleRegistrationDocument.validationHeadline': 'Відсутні фотографії',
	'vehicleRegistrationDocument.validationDescription': 'Додайте такі фотографії:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Сфотографуйте свідоцтво про реєстрацію',
	'review.stepDescription.vehicleRegistrationDocument':
		'Свідоцтво про реєстрацію транспортного засобу',
	'blockedByDevice.headline': 'PolicyCheck не підтримує настільні браузери',
	'blockedByDevice.description':
		'PolicyCheck використовує веб -переглядач на робочому столі.\r\nПлатформа PolicyCheck здійснює документування справ за допомогою мобільних пристроїв.\r\nЩоб продовжити, запустіть посилання PolicyCheck на мобільному пристрої.',

	'button.accept': 'Прийняти',
	'button.close': 'Закрий це',
	'button.changeImage': 'Змінити фото',
	'button.deleteImage': 'Видалити фото',
	'button.next': 'Далі',
	'button.start': 'почати',
	'button.prev': 'Попередній',
	'button.continue': 'Продовжуйте',
	'button.ok': 'в порядку',
	'button.addLater': 'Додайте пізніше',
	'button.backchangeImage': 'Назад і змінити зображення',

	'completeFourAdditionalPicturesModal.description': 'Будь ласка, додайте таку інформацію:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Фото пробігу',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Панель приладів автомобіля',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Фото номер VIN',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Зображення лобового скла',
	'completeFourAdditionalPicturesModal.headline': 'Підказка',
	'completeVehicleImagesModal.headline': 'Підказка',
	'completeVehicleImagesModal.description': 'Будь ласка, додайте таку інформацію',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft':
		'Діагональне фото передньої - лівої сторона',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Діагональне фото передньої - правої сторони',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Діагональне фото задньої - лівої сторони',
	'completeVehicleImagesModal.hasVehicleImageRearRight':
		'Діагональне фото задньої - правої сторони',

	'dashboardMileage.placeholder': 'наприклад 150000 км',
	'dashboardMileage.dashboard.paragraph':
		'Сфотографуйте приладову панель автомобіля з повністю видимим пробігом. Якщо ваш автомобіль має електронні дисплеї, увімкніть їх.',
	'dashboardMileage.paragraph.first': 'Введіть пробіг автомобіля.',
	'dataPrivacyModal.headline': 'Умови та положення',

	'editPhoto.edit': 'зміна',

	'imageRecognitionFeedback2.exemplaryPhoto': 'Зразкове фото',
	'imageRecognitionMismatchModal.headline': 'Ви впевнені, що додали правильну фотографію?',

	'landing.aboutPolicyCheck': 'Що таке PolicyCheck?',
	'landing.changeLang': 'Щоб змінити мову, натисніть тут.',
	'chooseLang.headline': 'Виберіть бажану мову',
	'landing.dataPrivacyLink': 'Продовжуючи, ви погоджуєтесь з нашими умовами',
	'landing.headline.policyCheck': 'Ласкаво просимо',
	'landing.paragraph': 'Вам потрібно лише три кроки до завершення процесу',
	'landing.termsAndConditionsLink': 'Продовжуючи, ви погоджуєтесь з нашими умовами',
	'landing.termsAndConditionsLinkDescription': 'Продовжуючи, ви погоджуєтесь з нашими умовами',
	'landing.stepDescription.fourAdditionalPictures': 'Завантажте фотографії',
	'landing.stepDescription.fourDiagonalPerspectives': 'Зробіть потрібні фотографії',
	'landing.stepDescription.feedback': 'Надішліть нам свій відгук',
	'loader.error': 'Не вдалося завантажити ваш процес. Будь-ласка спробуйте пізніше...',
	'loader.loading': 'Завантаження даних ...',

	'feedback.headline.policyCheck': 'Картинки отримані успішно!',
	'feedback.description': ' ',
	'feedback.rating.policyCheck':
		'На скільки зірок ви оцініюте додаток з урахуванням вашого першого досвіду роботи з додатком, по 5 бальній системі оцінки?',
	'feedback.button.send': 'Надіслати',
	'feedback.yourOpinion': 'Коментарі?',

	'fourAdditionalPictures.mileage.description':
		'Сфотографуйте, будь ласка, свій пробіг. Якщо ваш автомобіль має цифровий дисплей, увімкніть його.',
	'fourAdditionalPictures.mileage.enter': 'Введіть пробіг автомобіля',
	'fourAdditionalPictures.mileage.title': 'Пробіг',
	'fourAdditionalPictures.overallDashboard.description':
		'Сфотографуйте повністю приладову панель свого автомобіля.',
	'fourAdditionalPictures.overallDashboard.title': 'Панель приладів автомобіля',
	'fourAdditionalPictures.title': 'Додаткові фотографії',
	'fourAdditionalPictures.vin.description':
		'Сфотографуйте номер VIN вашого автомобіля. Ви можете знайти це на ущільнювачі водійських дверей або в нижньому лівому куті лобового скла.',
	'fourAdditionalPictures.vin.title': 'Номер VIN транспортного засобу',
	'fourAdditionalPictures.windshield.description':
		'Зробіть детальне фото переднього лобового скла вашого автомобіля',
	'fourAdditionalPictures.windshield.title': 'Переднє лобове скло автомобіля',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Зразкове фото',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Зразкове фото',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Зразкове фото',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Зразкове фото',

	'fourDiagonalPerspectives.vehicleFrontRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Зразкове фото',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Зразкове фото',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Зразкове фото',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Зразкове фото',

	'fourPerspectivesExampleModal.button.close': 'Закрити',
	'fourPerspectivesExampleModal.headline.first': 'Оглядові фотографії автомобіля - приклад',

	'mainError.tryAgain': 'Спробуйте ще раз',
	'overallDashboardImage.headline': 'Загальне зображення інформаційної панелі',

	'review.button.next': 'Далі',

	'tutorialModal.headline.first.policyCheck': 'Що стоїть за PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck - це швидкий огляд автомобіля. Процес перевірки складається з 8 простих кроків.',
	'tutorialModal.paragraph.second': ' ',

	'timeout.bottom': ' ',

	'upload.message':
		'Ваші дані будуть завантажені. Залежно від вашого підключення до Інтернету цей процес може зайняти кілька хвилин.',

	'waitForAudit.description': 'Дані успішно подані.',
	'waitForAudit.description.damageFound': 'Дані успішно подані.',
	'waitForAudit.description.damageNotFound': 'Дані успішно подані.',
	'waitforAudit.finish': 'Готово',
	'waitForAudit.thankYou': 'Дякуємо, що довіряєте нам',

	'windshieldImage.headline': 'Зображення лобового скла',

	'vehicleImages.leftFrontOverview': 'Діагональне фото передньої - лівої сторона',
	'vehicleImages.leftRearOverview': 'Діагональне фото задньої - лівої сторони',
	'vehicleImages.rightFrontOverview': 'Діагональне фото передньої - правої сторони',
	'vehicleImages.rightRearOverview': 'Діагональне фото задньої - правої сторони',
	'vehicleImages.overviewPhotos': 'Огляд автомобіля',
	'vehicleImages.overviewPhotos.subtitle': 'Фотографія транспортного засобу',
	'vehicleImages.description':
		'Фотографуйте транспортний засіб по діагоналі спереду ліворуч та праворуч, ззаду ліворуч та праворуч. Номерний знак повинен бути видно на всіх знімках',

	'vinPicture.headline': 'Фото номер VIN',

	'testcasemodal.headline': 'Попередження про тестовий приклад!',
	'testcasemodal.accept': 'Прийняти',
	'testcasemodal.paragraph': 'Майте на увазі, що це тестовий випадок!',
	'testcasewarningalert.paragraph': 'Це тестовий приклад!',

	'invalidFile.size.title': 'Неправильний розмір зображення',
	'invalidFile.size.description': 'Розмір зображення більший за максимально необхідний',
	'invalidFile.extension.title': 'Тип файлу не підтримується',
	'invalidFile.extension.description':
		'Вказаний тип файлу не підтримується. Підтримувані типи файлів: .jpg, .jpeg, .jfif, .heic, .heif, .png та .bmp',
};

export default messages;
